import PropTypes from 'prop-types';

export default function OutlinePrint(props) {
    const { color = 'currentColor', size = 20, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M16.771 5.625h-1.146v-2.5A.625.625 0 0 0 15 2.5H5a.625.625 0 0 0-.625.625v2.5H3.229c-1.091 0-1.979.841-1.979 1.875v6.25a.625.625 0 0 0 .625.625h2.5v2.5A.625.625 0 0 0 5 17.5h10a.624.624 0 0 0 .625-.625v-2.5h2.5a.624.624 0 0 0 .625-.625V7.5c0-1.034-.887-1.875-1.979-1.875ZM5.625 3.75h8.75v1.875h-8.75V3.75Zm8.75 12.5h-8.75V12.5h8.75v3.75Zm3.125-3.125h-1.875v-1.25A.624.624 0 0 0 15 11.25H5a.625.625 0 0 0-.625.625v1.25H2.5V7.5c0-.345.327-.625.729-.625H16.77c.402 0 .729.28.729.625v5.625Zm-1.875-4.063a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Z"
                fill={color}
            />
        </svg>
    );
}

OutlinePrint.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
